import { Context, Dispatch, useState } from "react";
import { ReactNode } from "react";
import FilterIcon from "../icons/FilterIcon";
import Button from "@/components/bricks/button/Button";
import CollapseIcon from "../icons/CollapseIcon";
import { Collapsible } from "radix-ui";
import FilterPresetsDropdown from "./presets/FilterPresetsDropdown";
import FilterPresetsModal from "./presets/FilterPresetsModal";
import { useFilterPresets } from "../../hooks/useFilterPresets";
import {
  FilterKeys,
  FilterPreset,
  QueryFilterEvent,
} from "../../interfaces/filters";
import useLocalStorageState from "use-local-storage-state";

export default function FiltersSidebar<Keys extends FilterKeys>({
  children,
  contextType,
  queryFilterEventContext,
  onReset,
}: {
  children: ReactNode;
  contextType: FilterPreset["type"];
  queryFilterEventContext: Context<Dispatch<QueryFilterEvent<Keys>>>;
  onReset: () => void;
}) {
  const [collapsibleOpen, setCollapsibleOpen] = useLocalStorageState(
    "collapsibleOpen",
    { defaultValue: true },
  );
  const [container, setContainer] = useState<null | HTMLDivElement>(null);

  useFilterPresets(contextType);

  return (
    <Collapsible.Root
      open={collapsibleOpen}
      onOpenChange={setCollapsibleOpen}
      className="c-collapsible bg-light"
    >
      <Collapsible.Trigger className="c-collapsible-trigger" asChild>
        <Button
          icon
          transparent
          color="secondary"
          aria-label={collapsibleOpen ? "Skjul panel" : "Åbn filtre"}
          className={collapsibleOpen ? "tooltip-end" : ""}
          onClick={() => {}}
        >
          {collapsibleOpen ? <CollapseIcon /> : <FilterIcon />}
        </Button>
      </Collapsible.Trigger>
      <Collapsible.Content className="h-100">
        <div className="l-sidebar" ref={setContainer}>
          <header className="navbar navbar--sub bg-light">
            <div>
              <span className="me-2">
                <FilterIcon />
              </span>
              <h2 className="fw-medium">Filtre</h2>
            </div>
            <div className="justify-content-end gap-4 pe-4 me-4">
              <FilterPresetsDropdown
                container={container}
                contextType={contextType}
                queryFilterEventContext={queryFilterEventContext}
              />
            </div>
          </header>
          <div className="l-sidebar__scrollable pb-3">{children}</div>
          <footer className="navbar navbar--sub navbar--footer bg-light position-static">
            <FilterPresetsModal
              container={container}
              contextType={contextType}
            />
            <button
              className="btn btn-secondary btn--transparent"
              onClick={() => {
                onReset();
              }}
            >
              Nulstil
            </button>
          </footer>
        </div>
      </Collapsible.Content>
    </Collapsible.Root>
  );
}
